import { IStoreState } from 'modules/types';

export const getTrackList = (state: IStoreState) => state.tracks.list;
export const getTracksFetched = (state: IStoreState) => state.tracks.isFetched;
export const missingTrackList = (state: IStoreState) => !state.tracks.isFetching && state.tracks.list.length === 0;
export const getTracksFetching = (state: IStoreState) => state.tracks.isFetching;
